import axios from 'axios';
import globals from "../config/appconfig";
import OggettiUtili from "../utils/OggettiUtili"

export default class FocolaiServices {

    static urlInsertFocolai = globals["app-url-backend-focolai"] + "/creazionefocolaio"
    static urlGetFocolaio = globals["app-url-backend-focolai"] + "/{idFocolaio}"
    static urlModificaFocolaio = globals["app-url-backend-focolai"] + "/{idFocolaio}"
    static urlArchiviaFocolaio = globals["app-url-backend-focolai"] + "/{idFocolaio}/archivia"
    static urlFocolai = globals["app-url-backend-focolai"] + "/sintesifocolai"

    // static urlFocolai = "http://localhost:8085/api/v1/focolai/sintesifocolai" //mockup per run locale

    static getFocolai(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlFocolai + querystring)
    }

    // chiamata per inserire un nuovo Focolaio

    static postInserimentoFocolaio(jsonInsert) {

        return axios.post(this.urlInsertFocolai, jsonInsert)

    }


    // chiamata per modificare un Focolaio

    static putModificaFocolaio(jsonInsert, uuidFocolaio) {

        return axios.put(this.urlModificaFocolaio.replace("{idFocolaio}", uuidFocolaio), jsonInsert)

    }


    //Chiamata per prendere i dati del focolaio cercando per uuid

    static getFocolaio(uuidFocolaio) {
        return axios.get(this.urlGetFocolaio.replace("{idFocolaio}", uuidFocolaio))
            .then(response => {
                if (response.data && response.data.differenzeAudit)
                    response.data.differenzeAudit = JSON.parse(response.data.differenzeAudit)
                return Promise.resolve(response)
            }).catch(err => {
                throw err
            })
    }

    //chiamata per modificare lo stato del focolaio (archiviazione)
    static postArchiviaFocolaio(uuidFocolaio) {
        return axios.post(this.urlArchiviaFocolaio.replace("{idFocolaio}", uuidFocolaio));
    }

    static mapGetFocolai(data) {

        let malattia = JSON.parse(sessionStorage.getItem("malattiePerCodice"));
        let regione = OggettiUtili.Regioni;
        let comune = JSON.parse(sessionStorage.getItem("comuniPerCodice"));
        let provincia = JSON.parse(sessionStorage.getItem("provincePerCodice"));
        let comunita = OggettiUtili.Collettivita;

        let codiceRegione=data.data.regione
        if (codiceRegione.length===2){
            codiceRegione=codiceRegione.concat("0")
        }

        let res = {
            malattia: malattia[data.data.malattia] ? malattia[data.data.malattia] : "",
            regione: regione[codiceRegione] ? regione[codiceRegione] : "",
            comune: comune[data.data.comune] ? comune[data.data.comune] : "",
            provincia: provincia[data.data.provincia] ? provincia[data.data.provincia] : "",
            comunita: comunita[data.data.comunita] ? comunita[data.data.comunita] : "",
        }

        return res
    }

}
